import "../legal/PrivacyPolicyPage.css";

const PrivacyPolicy = () => {
  return (
    <main className="legal-page">
      <div className="legal-page__container">
        <header className="legal-page__header">
          <span className="legal-badge">
            <a href="https://www.rxconnect.ca/" target="_blank" rel="noopener noreferrer">
              Rx Connect Specialty Pharmacy
            </a>
          </span>
          <h1>Privacy Policy</h1>
          <p>
            This policy explains, in plain language, what personal data{" "}
            <a href="https://www.rxconnect.ca/" target="_blank" rel="noopener noreferrer">
              Rx Connect Specialty Pharmacy
            </a>{" "}
            collects, why we collect it, and what choices and rights you have.
          </p>
        </header>

        <section className="legal-section">
          <h2>Data We Collect</h2>
          <p>Depending on how you use our services, we may collect:</p>
          <ul>
            <li>your name</li>
            <li>your email address</li>
            <li>your phone number</li>
            <li>
              health information, when relevant to your treatment, support, or
              referral
            </li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Why We Collect It</h2>
          <p>
            We collect this information to respond to your enquiries, provide
            pharmacy and support services, coordinate care, and meet safety and
            regulatory requirements.
          </p>
        </section>

        <section className="legal-section">
          <h2>Our Legal Basis</h2>
          <p>We process data under one or more legal bases:</p>
          <ul>
            <li>
              <strong>Consent</strong> - when you clearly agree to specific uses
              of your information.
            </li>
            <li>
              <strong>Legitimate interest</strong> - when processing is
              reasonably necessary to run and improve services, while respecting
              your rights.
            </li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Who We Share Data With</h2>
          <p>Where needed, we may share information with:</p>
          <ul>
            <li>Rx Connect internal teams involved in your care or request</li>
            <li>healthcare providers supporting your treatment</li>
            <li>
              PSPs (patient support programs) that help coordinate approved
              support services
            </li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>How Long We Keep Data</h2>
          <p>
            If you do not become an active patient, we typically retain your
            enquiry data for <strong>6 to 12 months</strong>. If you become a
            patient, we keep records as required by healthcare and legal
            obligations.
          </p>
        </section>

        <section className="legal-section">
          <h2>Data Security</h2>
          <p>
            We use appropriate administrative, technical, and physical
            safeguards to protect your personal information.
          </p>
        </section>

        <section className="legal-section">
          <h2>Your Rights</h2>
          <p>You can ask us to:</p>
          <ul>
            <li>provide access to your personal data</li>
            <li>correct inaccurate or incomplete information</li>
            <li>delete data where deletion rights apply</li>
          </ul>
          <p>
            You can also ask questions about how we process your information at
            any time.
          </p>
        </section>

        <section className="legal-section legal-section--contact">
          <h2>Privacy Contact</h2>
          <p>
            For privacy requests, contact{" "}
            <a href="mailto:info@sandyrandhawa.com">info@sandyrandhawa.com</a>{" "}
            or call <a href="tel:01900123456">01900 123456</a>. We will review
            your request and respond as quickly as possible.
          </p>
        </section>
      </div>
    </main>
  );
};

export default PrivacyPolicy;
